// dependencies
import React, { useRef, useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import sendAnalytics from '@st-operations/uikit/lib/sendAnalytics.js'
import { Button, BUTTON_THEME, Input } from '@st-operations/uikit/src/v2/index.js'

import './styles.scss'

const ENTITY = 'custom-taxonomies'

const CreateCustomTaxonomiesModal = ({
  value,
  open,
  title = 'New Custom Taxonomy',
  onClose = () => {},
}) => {
  const [name, setName] = useState('')

  const inputRef = useRef()

  useEffect(() => {
    if (value) {
      setName(value)
    }
  }, [value])

  useEffect(() => {
    if (open) {
      inputRef.current.focus()
    }
  }, [open])

  const onCreate = () => {
    window._api.post(`/${ENTITY}`, { name }, (error, item) => {
      if (error) {
        toast.error(error.message)
      } else {
        onClose()
        window._history.push(`/${ENTITY}/${item._id}`)
      }

      // event tracking
      sendAnalytics('create', ENTITY, item)
    })
  }

  const onDismiss = () => {
    onClose()
  }

  const onKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault()
      onCreate()
    }
    if (e.key === 'Escape' || (e.metaKey && e.key === 'e')) {
      e.preventDefault()
      onDismiss()
    }
  }

  const updateName = (value) => {
    setName(value)
  }

  return (
    <section className="st-new-entity-modal">
      <If condition={title}>
        <h1 className="st-new-entity-modal__title">{title}</h1>
      </If>
      <Input ref={inputRef} onChange={updateName} onKeyDown={onKeyDown} value={name} label="Name" />
      <div className="mt-4 flex justify-end">
        <Button
          className="st-new-entity-modal__button"
          theme={BUTTON_THEME.SECONDARY}
          onClick={onDismiss}
        >
          Back
        </Button>
        <Button className="st-new-entity-modal__button" onClick={onCreate}>
          Create
        </Button>
      </div>
    </section>
  )
}

CreateCustomTaxonomiesModal.propTypes = {
  title: PropTypes.string,
  label: PropTypes.string,
  open: PropTypes.bool,
  defaultProperties: PropTypes.shape(),
  urlRedirect: PropTypes.string,
  entities: PropTypes.string,
  value: PropTypes.string,
  onClose: PropTypes.func,
}

CreateCustomTaxonomiesModal.defaultProperties = {
  title: '',
  label: 'Name',
  open: false,
  defaultProperties: {},
  urlRedirect: '',
  entities: '',
  value: '',
  onClose: () => {},
}

// export
export default React.memo(CreateCustomTaxonomiesModal)
